var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DocumentCreatedIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '16' : _b, _c = _a.height, height = _c === void 0 ? '16' : _c;
    return (_jsxs("svg", __assign({ width: width, height: height, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "8", cy: "8", r: "5.75", stroke: "#6B7280", strokeWidth: "1.25" }), _jsx("path", { d: "M8 5.25V10.75", stroke: "#6B7280", strokeWidth: "1.25", strokeLinecap: "round" }), _jsx("path", { d: "M5.25 8H10.75", stroke: "#6B7280", strokeWidth: "1.25", strokeLinecap: "round" })] })));
};
